import { Upload } from "../upload.model";
import { ItemStateModel } from "./item-state.model";

export class UploadBatchState extends ItemStateModel {
    uploadBatches: Upload[];
    caseUploadBatchCount: number;
}
